import Dexie, { type EntityTable } from 'dexie'

/** Local copy of everything the app needs; the screens never wait for the network */
export interface SeriesRow {
  /** `${station}:${year}:${kind}` */
  key: string
  station: string
  year: number
  kind: 'levels' | 'extrema'
  hash: string
  bytes: Uint8Array
}

export interface KvRow {
  key: string
  value: unknown
}

export const db = new Dexie('quicktide') as Dexie & {
  series: EntityTable<SeriesRow, 'key'>
  kv: EntityTable<KvRow, 'key'>
}

db.version(1).stores({
  series: 'key, station, year',
  kv: 'key'
})

export async function kvGet<T>(key: string): Promise<T | undefined> {
  return (await db.kv.get(key))?.value as T | undefined
}

export async function kvSet(key: string, value: unknown): Promise<void> {
  await db.kv.put({ key, value })
}
